import apiClient from '../apiClient';
import { PUT_PAYMENT_SCHEME_URL } from '../apiUrl';

const putPaymentSchemeApi = (id, data) => {
  return apiClient.put(PUT_PAYMENT_SCHEME_URL(id), data);
};

export default putPaymentSchemeApi;
